import PropTypes from "prop-types";
import { useRef, useEffect, useState } from "react";

const Notification = (props) => {
  const [title, setTitle] = useState("");
  const [desc, setDesc] = useState("");
  const notifArea = useRef(null);

  const { data } = props;

  useEffect(() => {
    if (data.warning) {
      setTitle(data.warning.title);
      setDesc(data.warning.description);
    } else {
      notifArea.current.remove();
    }
  }, []);

  const closeNotification = () => {
    notifArea.current.remove();
  };

  return (
    <div
      ref={notifArea}
      className="flex absolute bg-indigo-200 top-6 inset-x-0 mx-auto w-2/3 md:w-1/4 p-4 rounded-lg card shadow-md ease-in-out duration-500 z-50"
    >
      <div className="flex-1 flex flex-col font-semibold text-gray-700 break-words">
        <span>{title}</span>
        <span>{desc}</span>
      </div>
      <div className="ml-4">
        <button onClick={closeNotification}>
          <span className="text-gray-600 font-semibold text-3xl">&times;</span>
        </button>
      </div>
    </div>
  );
};

Notification.propTypes = {
  data: PropTypes.object,
};

export default Notification;
